import { createSvgIcon } from '@mui/material'

export const DataCastIcon = createSvgIcon(
  <path d="M20 4H4c-.978 0-1.778.8-1.778 1.778v2.666H4V5.778h16v12.444h-6.222V20H20c.978 0 1.778-.8 1.778-1.778V5.778C21.778 4.8 20.978 4 20 4ZM2.222 17.333V20H4.89a2.663 2.663 0 0 0-2.667-2.667Zm0-3.555v1.778A4.446 4.446 0 0 1 6.667 20h1.777a6.218 6.218 0 0 0-6.222-6.222Zm0-3.556V12a8 8 0 0 1 8 8H12c0-5.404-4.382-9.778-9.778-9.778Z" />,
  'DataCastIcon'
)
